import _ from '../../utils/underscore';
import {BUTTON_TYPE} from './message_consts';
import ServiceFactory from '../../services/service_factory';

const BUTTONS_DEFAULT_CLASS = 'cgp-msg-button cgp-theme-property-corner-radius';

class MessageButton {

    /**
     * Build message button wuth options
     * @params
     * params {object}
     * {
     *  name, isClosable, id, cssClass, callback, isSendAnalytic
     * }
     * @name {string} - button text. Default = 'OK'
     * @isClosable {bool} - whether button can close the dialog (usable in message_component). Default = true
     * @id {string} - button unique id. Default value is autogenerated ID
     * @cssClass {stirng} - custom css class. Will be added to default button class 'cgp-msg-button'
     * @type {string} - define whether CTA is main or secondary
     * @callback {function} - define custom behavior on button click.
     * @forceAnalytic (bool) - whether button have to send default analytic event. Default = false. If need to force it and send another analytic event,
     * you must define custom button, set this property to be 'false' and fire event via callback function
     *
     */
    constructor(params) {
        let defaults = {
            name: ServiceFactory.create().languageService().translation('mdp_ok'),
            isClosable: true,
            id: _.makeid(),
            cssClass: '',
            callback: () => {},
            type: BUTTON_TYPE.MAIN.typeName,
            forceAnalytic: false
        }

        this._options = {};
        Object.assign(this._options, defaults, params)
        let buttomTypeClass = BUTTON_TYPE[this._options.type.toUpperCase()].class || '';
        // fix class
        this._options.cssClass = BUTTONS_DEFAULT_CLASS + ' ' + buttomTypeClass + ' ' + this._options.cssClass;

    }

    getOptions() {
        return this._options;
    }
}

export default MessageButton;